import { useMemo } from 'react'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { AspectRatioKey } from 'components/NewFileModal/Types'
import { useGroups } from 'components/Wizards/Catalogue/useGroups'
import { TextChannelKey, TurnInto } from 'types'

export const VISUAL_STUDIO_KEYS = [
  'instagram-square-post',
  'instagram-story',
  'instagram-reel',
  'instagram-portrait-post',
  'instagram-landscape-post',
  'tik-tok-post',
  'tik-tok-thumbnail',
  'youtube-channel-art',
  'youtube-profile-picture',
  'facebook-cover',
  'facebook-post',
  'facebook-marketplace',
  'facebook-profile-picture',
  'linkedin-profile-picture',
  'linkedin-post',
  'linkedin-banner',
  'whatsapp-sticker',
  'pinterest',
  'ebay',
  'poshmark',
  'depop',
  'mercari',
  'mercadolibre',
  'shopee',
  'lazada',
  'etsy',
  'vinted',
  'amazon',
  'shopify-square',
  'landscape-post',
  'portrait-post',
  'square-post',
  'twitter-post',
  'twitter-profile-picture',
  'twitter-cover-image',
  'youtube-short',
]

export const useFeatureFlaggedGroups = ({
  hiddenKeys: initialHiddenKeys = [],
}: { hiddenKeys?: Array<AspectRatioKey | TurnInto | TextChannelKey> } = {}) => {
  const isVisualStudioEnabled = useFlipperFlag('visual_studio')

  const hiddenKeys = useMemo(() => {
    const hiddenKeysSet = new Set<TurnInto | AspectRatioKey | TextChannelKey>(initialHiddenKeys)

    if (isVisualStudioEnabled) {
      return hiddenKeysSet
    }

    if (!isVisualStudioEnabled) {
      VISUAL_STUDIO_KEYS.forEach((key) => hiddenKeysSet.add(key as AspectRatioKey))
    }

    return hiddenKeysSet
  }, [isVisualStudioEnabled, initialHiddenKeys])

  return useGroups(hiddenKeys)
}
